export default __webpack_public_path__ + "static/media/binger.4cdbb61f.png";